<template>
    <div class="step-wrapper">
        <div class="step-header">
            <h2 class="step-title">Do you have an eviction on record?</h2>
        </div>

        <div class="step-body">
            <CardSelector
                :options="evictionOptions"
                :value="selectedValue"
                @input="onSelect"
            />
        </div>

        <div class="step-footer">
            <v-btn
                color="primary"
                depressed
                block
                height="50"
                :disabled="selectedValue === null"
                @click="onNext"
                class="next-btn"
            >
                Next
            </v-btn>
        </div>
    </div>
</template>

<script>
import CardSelector from '../shared/CardSelector.vue';

export default {
    name: 'EvictionStep',

    components: {
        CardSelector
    },

    data() {
        return {
            evictionOptions: [
                {
                    value: false,
                    label: 'No',
                    icon: 'mdi-check-circle-outline'
                },
                {
                    value: true,
                    label: 'Yes',
                    icon: 'mdi-alert-circle-outline'
                }
            ]
        };
    },

    computed: {
        selectedValue() {
            return this.$store.getters['Questionnaire/getAnswer']('hasEviction');
        }
    },

    methods: {
        onSelect(value) {
            this.$store.dispatch('Questionnaire/setAnswer', {
                key: 'hasEviction',
                value
            });
        },

        onNext() {
            if (this.selectedValue !== null) {
                this.$emit('next');
            }
        }
    }
};
</script>

<style scoped>
.step-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.step-header {
    text-align: center;
    margin-bottom: 32px;
}

.step-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
}

.step-body {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.step-footer {
    margin-top: auto;
    padding-top: 24px;
}

.next-btn {
    font-weight: 600;
    text-transform: none;
    font-size: 16px;
    border-radius: 8px;
}
</style>
